import axios from "axios";
export var role_name = "";
export var role_send_data = "";
export var all = [];
export var arr = [];

export var perm_data = async () => {
  if (arr.length === 0) {
    await axios
      .get(`/api/v1/auth/roles`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "JWT " + localStorage["token"],
        },
      })
      .then((x) => {
        all = x.data.data.role_all;
        arr = x.data.data.new_role;
        role_name = x.data.data.role_name;
        role_send_data = x.data.data.role_send_data;
        //console.log(arr)
      })
      .catch((x) => {
        console.log("authen error");
      });
  }
};

export var perm = (id, type) => {
  var check = arr.findIndex(
    (i) => _.toNumber(i.perm_item_id) === _.toNumber(id) && _.toNumber(i.perm_action_type_id) === _.toNumber(type)
  );

  if (check >= 0) {
    return true;
  } else {
    return false;
  }
};

export var perm_t = (id) => {
  var check = arr.findIndex(
    (i) => i.topic_id === id && i.perm_action_type_id === 1
  );

  if (check >= 0) {
    return true;
  } else {
    return false;
  }
};


export var perm_s = (id) => {
  var check = arr.findIndex(
    (i) => i.sub_topic_id === id && i.perm_action_type_id === 1
  );

  if (check >= 0) {
    return true;
  } else {
    return false;
  }
};
